// extracted by mini-css-extract-plugin
module.exports = {"hitArea":"CompareImage_hitArea___I8vZ","dragIcon":"CompareImage_dragIcon__2wHg2"};